import { Slider } from "primereact/slider";

import GraficoPrevisao from "./GraficoPrevisao";
import TabelaPrevisao from "../../Tabelas/TabelaPrevisao";

const MediaMovel = ({ periods, setPeriods, series, futureLabels, forecasts, available }) => (
  <>
    <div className="p-field p-mb-4" style={{ maxWidth: 420 }}>
      <label>Períodos considerados: {periods}</label>
      <Slider min={2} max={6} value={periods} onChange={(event) => setPeriods(event.value)} />
    </div>
    <p>A MMS atende produção estável. A MMP dá mais peso aos meses recentes. Ambos os métodos têm limitações com sazonalidade e picos.</p>
    {available ? (
      <>
        <GraficoPrevisao
          series={series}
          futureLabels={futureLabels}
          methods={[
            { key: "simple", method: forecasts.simple },
            { key: "weighted", method: forecasts.weighted },
          ]}
        />
        <TabelaPrevisao
          series={series}
          futureLabels={futureLabels}
          methods={[
            { key: "simple", method: forecasts.simple },
            { key: "weighted", method: forecasts.weighted },
          ]}
        />
      </>
    ) : null}
  </>
);

export default MediaMovel;
